import React, { useMemo } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { MutateSetPitScenario } from "../../../utils/graphql/hooks/raceDataHooks";

export default function PitControls({ carColour }: { carColour: string }) {
  const raceConfig = useSelector(
    (state: RootState) => state.raceData[carColour]?.raceConfig,
    isEqual,
  );

  const jagDrivers = useSelector(
    (state: RootState) => state.imports.derivedImportData.strategy.jagDrivers,
    isEqual,
  );

  const driverInfo = useSelector(
    (state: RootState) => state.imports.derivedImportData.strategy.driverInfo,
    isEqual,
  );

  const EPitBoostVsScenario = useSelector(
    (state: RootState) =>
      state.imports.imports.strategy?.data.EPitBoostVsScenario,
    isEqual,
  );

  const carHighlightColor = useMemo(() => {
    const driverNumber = jagDrivers?.[carColour];
    if (driverNumber && driverInfo?.[driverNumber]?.driverHighlightColourAlt) {
      return driverInfo[driverNumber].driverHighlightColourAlt;
    }
    return "#ffffff";
  }, [jagDrivers, driverInfo, carColour]);

  const setPitScenario = MutateSetPitScenario();

  const hasPitted = raceConfig?.pitLap !== null;
  const currentScenario = raceConfig?.pitScenario ?? 3;

  const handleScenarioChange = (scenario: number) => {
    if (scenario !== currentScenario) {
      setPitScenario({ variables: { carColour, pitScenario: scenario } });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.pitScenarioContainer}>
        <>
          {EPitBoostVsScenario?.map((energy, index) => {
            const scenario = index + 1;
            const label = `${energy.toFixed(2)} kWh`;
            return (
              <label key={scenario} className={styles.radioOption}>
                <input
                  type="radio"
                  name={`pitScenario-${carColour}`}
                  disabled={hasPitted}
                  checked={currentScenario === scenario}
                  onChange={() => handleScenarioChange(scenario)}
                />
                <span
                  style={
                    currentScenario === scenario
                      ? { color: carHighlightColor }
                      : undefined
                  }
                >
                  {label}
                </span>
              </label>
            );
          })}
        </>
      </div>
    </div>
  );
}
